// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_notfoundmessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `The page you're looking for doesn't exist. Check the URL or go back to the dashboard.`
};

const de_notfoundmessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `Die Seite, die Sie suchen, existiert nicht. Überprüfen Sie die URL oder gehen Sie zurück zum Dashboard.`
};

const es_notfoundmessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `La página que estás buscando no existe. Verifica la URL o regresa al tablero.`
};

const fr_notfoundmessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `La page que vous recherchez n'existe pas. Vérifiez l'URL ou retournez au tableau de bord.`
};

const ja_notfoundmessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `お探しのページは存在しません。URLを確認するか、ダッシュボードに戻ってください。`
};

const nl_notfoundmessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `De pagina die je zoekt bestaat niet. Controleer de URL of ga terug naar het dashboard.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "ja" | "nl" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const notfoundmessage2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.notfoundmessage2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("notfoundmessage2", locale)
	if (locale === "en") return en_notfoundmessage2(inputs)
	if (locale === "de") return de_notfoundmessage2(inputs)
	if (locale === "es") return es_notfoundmessage2(inputs)
	if (locale === "fr") return fr_notfoundmessage2(inputs)
	if (locale === "ja") return ja_notfoundmessage2(inputs)
	return nl_notfoundmessage2(inputs)
};
export { notfoundmessage2 as "notFoundMessage" }